import { IStudentsDashboardData } from 'src/apis/dashboard/dashboardStudents.interfaces';

export const dashboardStudentsMock: IStudentsDashboardData = {
  enrollment: {
    total: 1250,
    active: 1200,
    inactive: 50,
    newEnrollments: 45,
    byGrade: {
      '1': 120,
      '2': 115,
      '3': 110,
      '4': 105,
      '5': 100,
      '6': 95,
      '7': 90,
      '8': 85,
      '9': 80,
      '10': 75,
      '11': 70,
      '12': 65,
    },
  },
  attendance: {
    summary: {
      totalCount: 1200,
      attendancePercentage: 94.5,
      expectedCount: 1200,
    },
    status: {
      present: 1134,
      absent: 51,
      leave: 9,
      holiday: 6,
    },
  },
  period: {
    startDate: '2024-01-01',
    endDate: '2024-01-31',
  },
};
